import styles from "./styles.module.css";

export default function Card({ style, active, onClick }) {
  return (
    <div
      className={active ? styles.card + " " + styles.active : styles.card}
      onClick={() => onClick(style)}
    >
      <div>{style.name}</div>
      <div className={styles.subtext}>{style.component}</div>
    </div>
  );
}
